import { render, staticRenderFns } from "./CandidateItemSmall.vue?vue&type=template&id=27e7d9e7&scoped=true"
import script from "./CandidateItemSmall.vue?vue&type=script&lang=js"
export * from "./CandidateItemSmall.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemSmall.vue?vue&type=style&index=0&id=27e7d9e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7d9e7",
  null
  
)

export default component.exports